import { DataFetchingClient } from 'data-fetching-client';
import env from 'enviro';
import { PAGED_QUANTITY_PACK_FIELD_POLICIES } from 'pricing-pages-api/purchase-options/policies';
export const dataFetchingClient = new DataFetchingClient({
  connectToDevTools: env.isQa(),
  queryFieldPolicies: Object.assign({}, PAGED_QUANTITY_PACK_FIELD_POLICIES)
});